export default __webpack_public_path__ + "static/media/Mark-3-HUD-Targeting (Selector Ring).252ad76a.jpg";